import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//蓝天日历
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
var myChart;
var OnClick;
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-50px'
    },
    left: {
      type: String,
      default: '20px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {},
  methods: {
    getDaysInOneMonth: function getDaysInOneMonth(year, month) {
      month = parseInt(month, 10);
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    getVirtulData: function getVirtulData(year, month, dateData) {
      var dates = year + '-' + month + '-' + '1';
      var today = Date.parse(new Date(dates));
      var dayTime = 3600 * 24 * 1000;
      var thatday = today + dayTime * this.getDaysInOneMonth(year, month);
      var data = [];

      for (var time = today; time < thatday; time += dayTime) {
        data.push([echarts.format.formatTime('yyyy-MM-dd', time), 5]);
      }

      for (var i = 0; i < data.length; i++) {
        data[i][1] = dateData[i];
      }

      console.log('data', data);
      return {
        data: data,
        today: echarts.format.formatTime('yyyy-MM-dd', today),
        thatday: echarts.format.formatTime('yyyy-MM-dd', thatday)
      };
    },
    initBarChart: function initBarChart(year, month, dateData, colors, title) {
      var _this = this;

      var aqi = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
      console.log('title', title);
      console.log('aqi', aqi);
      console.log('colors', colors);

      var option = _defineProperty({
        // title: {
        //     top: 30,
        //     text: '2020年9月污染情况',
        //     subtext: '安徽合肥',
        //     left: 'center',
        // },
        visualMap: {
          min: 0,
          max: colors.length - 1,
          inRange: {
            color: colors
          },
          // inRange: {
          //     color: ['#ebedf0', '#c6e48b', '#7bc96f', '#239a3b', '#196027']
          // },
          show: false
        },
        tooltip: {
          show: true,
          formatter: function formatter(params) {
            console.log('params', params);

            if (aqi.length > 0) {
              return params.marker + params.data[0] + ':' + (title[params.data[1]] ? title[params.data[1]] : '暂无数据') + '\n' + 'AQI:' + aqi[params.dataIndex];
            } else {
              return params.marker + params.data[0] + ':' + (title[params.data[1]] ? title[params.data[1]] : '暂无数据');
            }
          }
        },
        // backgroundColor: '#fff',
        calendar: {
          cellSize: 'auto',
          orient: 'vertical',
          left: '6%',
          range: [this.getVirtulData(year, month, dateData)['thatday'], this.getVirtulData(year, month, dateData)['today']],
          itemStyle: {
            borderColor: 'rgba(255,255,255,0)',
            borderWidth: 4,
            color: 'rgba(255,255,255,0)'
          },
          splitLine: {
            show: false
          },
          // yearLabel: { show: false }
          yearLabel: {
            formatter: '2020年蓝天日历',
            fontSize: 12,
            margin: 30,
            show: false,
            color: '#fff'
          },
          monthLabel: {
            show: false,
            firstDay: 1,
            align: 'left',
            position: 'end',
            nameMap: 'cn',
            margin: 5,
            color: '#fff'
          },
          dayLabel: {
            firstDay: 1,
            margin: 10,
            nameMap: 'cn',
            textStyle: {
              color: '#fff'
            }
          }
        },
        series: {
          type: 'heatmap',
          coordinateSystem: 'calendar',
          data: this.getVirtulData(year, month, dateData)['data'],
          pointSize: 13,
          itemStyle: {
            normal: {
              color: '#f4e925'
            }
          },
          label: {
            show: true,
            formatter: function formatter(params) {
              return params.value[0].split('-')[2];
            },
            fontSize: 10,
            offset: [0, 0],
            textStyle: {
              color: '#000000'
            } // color: '#000000'

          }
        }
      }, "series", {
        type: 'heatmap',
        coordinateSystem: 'calendar',
        data: this.getVirtulData(year, month, dateData)['data'],
        pointSize: 13,
        itemStyle: {
          normal: {
            color: '#000'
          }
        },
        label: {
          show: true,
          formatter: function formatter(params) {
            return params.value[0].split('-')[2];
          },
          fontSize: 10,
          offset: [0, 0],
          textStyle: {
            color: '#000000'
          } // color: '#000000'

        }
      });

      var chart = this.$refs[this.chart];
      myChart && myChart.off('click', OnClick);

      OnClick = function OnClick(param) {
        if (title) {
          _this.$emit('content', title[param.value[1]], param.value[0]);
        }
      };

      myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      myChart.on('click', OnClick);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};